const tipsEN = [
  {
    title: 'Membership Packages',
    subtitle:
      'Boost retention and revenue using versatile memberships for single or multiple services, ranging from limited to unlimited offers, each with specific time validity.'
  },
  {
    title: 'SMS Marketing',
    subtitle: 'Launch targeted SMS campaigns to engage specific segments of your clientele.'
  },
  {
    title: 'Client Profile',
    subtitle: 'Centralize customer preferences, their visit history, and other metrics in a unified profile.'
  },
  {
    title: 'Analytics and Metrics',
    subtitle: 'Monitor crucial business metrics, sales trends, and industry-specific benchmarks.'
  },
  {
    title: 'Roster',
    subtitle: "Manage your staff's weekly roster effortlessly, with options for rotation."
  },
  {
    title: 'SMS Reminders',
    subtitle: 'Minimize last-minute cancellations and no-shows by sending timely SMS reminders.'
  },
  {
    title: 'User Permissions',
    subtitle: 'Customize data access and functionalities for each staff member, ensuring data integrity and security.'
  },
  {
    title: 'Multi-site Business Support',
    subtitle: 'Oversee multiple locations and evaluate the performance of each through a unified dashboard.'
  },
  {
    title: 'Rewards Program',
    subtitle:
      'Boost customer loyalty and average spending using our top-tier rewards program, rivaling those offered by major brands.'
  },
  {
    title: 'Automate Affection',
    subtitle:
      "Stay memorable by never missing your clients' birthdays or special occasions through marketing automation."
  },
  {
    title: 'Cash Register',
    subtitle: 'Monitor cash flow, manage expenses, and ensure every dollar is accounted for.'
  },
  {
    title: 'Inventory Management',
    subtitle: 'Keep tabs on, sell, and oversee both retail items and consumables.'
  },
  {
    title: 'Customer Feedback',
    subtitle:
      'Gather feedback post-visit, track your Net Promoter Score, and gauge customer satisfaction both overall and by staff member.'
  },
  {
    title: 'Referral Program',
    subtitle: 'Fuel growth with our autonomous referral program that operates seamlessly.'
  },
  {
    title: 'Targets and Goals',
    subtitle:
      'Set and achieve financial objectives using realistic targets. These are informed by industry standards and your current financial state, and are further detailed daily for each staff member.'
  }
]

const tipsAM = [
  {
    title: 'Խելացի նվեր քարտեր',
    subtitle:
      'Վաճառեք նվեր քարտեր օնլայն, սահմանեք վավերականությունը և սահմանափակումներն ըստ ծառայությունների: Նվեր քարտերը կարող են մարվել մասնակի և մեկից ավելին անգամ:'
  },
  {title: 'Գրանցումների կանխավճար', subtitle: 'Գրանցումների հաստատման համար կարող եք ավտոմատ գանձել կանխավճար'},
  {
    title: 'Օնլայն գրանցում',
    subtitle: 'Հարմարավետ գրանցման տարբերակ հասանելի 24x7, խնայեք ժամանակ և բարձրացրեք հաճախորդների գոհունակությունը'
  },
  {
    title: 'Ավտոմատացրեք աշխատավարձի հաշվարկը',
    subtitle: 'Ծառայությունից տոկոսի ավտոմատ հաշվարկիչ ըստ մասնագետի և ծառայութան:'
  },
  {
    title: 'Ծառայությունների փաթեթներ',
    subtitle: 'Փաթեթները հնարավորություն են տալիս վաճառել մի քանի ծառայություն զեղչված գնով'
  },
  {
    title: 'Թիրախավորված գովազդային SMS',
    subtitle:
      'Ուղարկեք գովազդային SMS հաճախորդների ենթախմբին օրինակ ըստ վերջին այցի, ծախված գումարի, կուտակված միավորների և այլն:'
  },
  {
    title: 'Հաճախորդի անհատական քարտ',
    subtitle: 'Տիրապետեք հաճախորդի ամբողջական պատմությանը, նախասիրություններին և ցուցանիշներին մեկ վայրում:'
  },

  {title: 'Ֆինանսական հաշվետվություն', subtitle: 'Հետևեք բիզնեսի կարևորագույն ցուցանիշներին իրական ռեժիմում:'},
  {
    title: 'Անձնակազմի աշխատանքային գրաֆիկ',
    subtitle: 'Սահմանեք շաբաթական աշխատանքային գրաֆիկը ռոտացիայի հնարավորությամբ:'
  },
  {
    title: 'SMS հիշեցումներ',
    subtitle: 'Զգալիորեն նվազեցրեք վերջին պահին չեղարկումները և մոռացված այցերը ավտոմատ SMS հիշեցումների միջոցով:'
  },
  {
    title: 'Ծրագրից օգտվելու իրավասություններ',
    subtitle: 'Սահմանափակեք անձնակազմին հասանելի ինֆորմացիան և հասանելի հնարավորությունները:'
  },
  {
    title: 'Մասնաճյուղերի կառավարում',
    subtitle: 'Ցանցային բիզնեսների գործիքակազմ բոլոր մասնաճյուղերի, անձնակազմի և գրանցումների կառավարման համար:'
  },
  {
    title: 'Կուտակային համակարգ',
    subtitle: 'Խթանեք հավատարմությունը և միջին կտրոնի բարձրացումը խելացի կուտակային համակարգի միջոցով:'
  },
  {
    title: 'Ավտոմատ շնորհավորանքներ',
    subtitle:
      'Ուղարկեք ծննդյան և այլ առիթներով ավտոմատ շնորհավորանքներ հաճախորդներին հավատարմությունը և սպասարկման որակը բարձրացնելու համար:'
  },
  {
    title: 'Դրամարկղ',
    subtitle: 'Վերահսկեք կանխիկի մուտքն ու ելքը, հետևեք ծախսերին և զրոյացրեք գումարի կորուստի հնարավորությունը:'
  },
  {title: 'Պահեստը և նյութածախս', subtitle: 'Վաճառեք ապրանքներ և վերահսկեք պահեստը և նյութածախսը:'},
  {
    title: 'Հետադարձ կապ',
    subtitle:
      'Ավտոմատ հավաքագրեք ծառայության գնահատական յուրաքանչյուր այցից հետո` հասանելի միայն ձեզ, վերահսկեք սպասարկման որակը:'
  }
]

const tipsRU = [
  {
    title: 'Абонементы',
    subtitle:
      'Повышайте удержание и доход с помощью универсальных абонементов для одной или нескольких услуг, от ограниченных до неограниченных предложений, каждое с определенным сроком действия.'
  },
  {
    title: 'SMS Маркетинг',
    subtitle: 'Запускайте целевые SMS-кампании для взаимодействия с определенными сегментами вашей клиентуры.'
  },
  {
    title: 'Профиль клиента',
    subtitle: 'Централизуйте предпочтения клиентов, историю их визитов и другие метрики в едином профиле.'
  },
  {
    title: 'Аналитика и метрики',
    subtitle: 'Отслеживайте ключевые бизнес-показатели, тенденции продаж и отраслевые бенчмарки.'
  },
  {
    title: 'Расписание сотрудников',
    subtitle: 'Управляйте еженедельным расписанием вашего персонала без усилий, с вариантами ротации.'
  },
  {
    title: 'SMS Напоминания',
    subtitle: 'Снижайте количество отмен в последнюю минуту и неприходов, отправляя своевременные SMS-напоминания.'
  },
  {
    title: 'Пользовательские разрешения',
    subtitle:
      'Настройте доступ к данным и функциональные возможности для каждого сотрудника, обеспечивая целостность данных и безопасность.'
  },
  {
    title: 'Поддержка мульти-локационного бизнеса',
    subtitle: 'Контролируйте несколько локаций и оценивайте производительность каждой через единую панель управления.'
  },
  {
    title: 'Программа лояльности',
    subtitle:
      'Повышайте лояльность клиентов и средний чек с помощью нашей высококлассной программы лояльности, соперничающей с программами крупных брендов.'
  },
  {
    title: 'Автоматизация Привязанности',
    subtitle:
      'Оставайтесь незабываемыми, никогда не пропуская дни рождения клиентов или особые случаи благодаря маркетинговой автоматизации.'
  },
  {
    title: 'Касса',
    subtitle: 'Контролируйте денежные потоки, управляйте расходами и убедитесь, что каждый доллар учтен.'
  },
  {
    title: 'Управление инвентарем',
    subtitle: 'Следите за товарами, продавайте и контролируйте как розничные товары, так и расходные материалы.'
  },
  {
    title: 'Отзывы клиентов',
    subtitle:
      'Собирайте отзывы после посещения, отслеживайте ваш Net Promoter Score и оценивайте удовлетворенность клиентов в целом и по каждому сотруднику.'
  },
  {
    title: 'Реферальная программа',
    subtitle: 'Способствуйте росту с помощью нашей автономной реферальной программы, работающей бесперебойно.'
  },
  {
    title: 'Цели и задачи',
    subtitle:
      'Ставьте и достигайте финансовых целей с помощью реалистичных задач, основанных на отраслевых стандартах и вашем текущем финансовом состоянии, а также детализированных ежедневно для каждого сотрудника.'
  }
]

module.exports = {
  en: tipsEN,
  am: tipsAM,
  ru: tipsRU
}
